import React from 'react';
import Layout from '../../components/layout/AppLayout';
import Header from '../../../shared/components/layout/Header';
import Reports from './Reports';
import { useSidebar } from '../../../shared/contexts/SidebarContext';
import { useLocation } from 'react-router-dom';
import { useSmartBack } from '../../../shared/navigation';

const ReviewMeeting = () => {
  const { collapsed } = useSidebar();
  const location = useLocation();
  const { onBack } = useSmartBack({ fallback: '/builder/sales/?view=dashboard' });

  return (
    <Layout>
      <div
        className={`fixed z-[10] top-0 transition-all duration-300 ease-in-out ${
          collapsed ? 'left-[76px] right-0' : 'left-64 right-0'
        }`}>
        <Header data={{ name: 'Sales Review Meeting' }} backArrow={true} onBack={onBack} />
      </div>
      <Reports
        mode={location.state?.mode}
        projectID={location.state?.projectID}
        month={location.state?.month}
      />
    </Layout>
  );
};

export default ReviewMeeting;
